{
    "warning": "चेतावनी!",
    "message": "कोई ऐसा कोड दर्ज या पेस्ट न करें जो आपकी समझ से परे हो।\nइस कंसोल का इस्तेमाल करने से हमलावर Self-XSS कहे जाने वाले हमले का इस्तेमाल करते हुए आपका भेष धारण करके आपकी जानकारी चुरा सकते हैं।"
}
